var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author Hyeongjin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-11-01
 * @brief EHP workorder - 노후 교체 컴포넌트
 *
 ********************************************************************/
import React, { useEffect, useState } from "react";
import { useAsync } from "react-async";
import { useNavigate } from 'react-router-dom';
// recoil
import { useRecoilValue, useRecoilState, } from "recoil";
import { userInfoLoginState } from "../../../../recoil/userState";
import { loadingBoxState, czoneInfoState, treeMenuState } from "../../../../recoil/menuState";
//utils
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import clog from "../../../../utils/logUtils";
import * as CUTIL from "../../../../utils/commUtils";
/**
 * @brief EHP WorkOrder - 노후 교체 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function ChangeTree(props) {
    //화면 이동
    const navigate = useNavigate();
    //recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const [isLoadingBox, setRecoilIsLoadinBox] = useRecoilState(loadingBoxState);
    const [czoneInfo, setRecoilCZoneInfo] = useRecoilState(czoneInfoState);
    const [treeOpen, setRecoilTreeOpen] = useRecoilState(treeMenuState);
    // props
    const isTreeOpen = props.isTreeOpen;
    const setParentIsTreeOpen = props.setIsTreeOpen;
    const isMobile = props.isMobile;
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const adminType = props.adminType;
    const setParentAdminType = props.setAdminType;
    const setParentWorkMode = props.setWorkMode;
    const workMode = props.workMode;
    const tabType = props.tabType;
    const setParentPopWin = props.setPopWin;
    //
    const [companyTree, setCompanyTree] = useState([]);
    // isMobile 여부 랜더링 후 확인
    useDebounceEffect(() => __awaiter(this, void 0, void 0, function* () {
        if (czoneInfo.zone.zoneId.length > 0) {
            const zoneTag = document.getElementById(`li_focus_${czoneInfo.zone.zoneId}`);
            if (!CUTIL.isnull(zoneTag)) {
                zoneTag.scrollIntoView();
                setRecoilCZoneInfo({ company: { companyId: "", companyName: "" }, zone: { zoneId: "", zoneName: "" } });
            }
        }
    }), 100, [companyTree]);
    const { data: retData, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/product/dashboard/usertree`,
        //appPath: `/api/v2/product/company/zone/subzone`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: adminType + workMode + selTree.reload
    });
    useEffect(() => {
        setRecoilIsLoadinBox(true);
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, retData);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (retData) {
            clog("IN WORKORDER : EHCTREE : RES : " /* + JSON.stringify(retData.body)*/);
            if (retData.codeNum == CONST.API_200) {
                setCompanyTree(retData.body);
                if (czoneInfo.zone.zoneId.length <= 0) {
                    setParentSelTree(adminType, Object.assign(Object.assign({}, selTree), { reload: false }));
                }
                else {
                    setParentSelTree(adminType, {
                        "company": { "companyId": czoneInfo.company.companyId, "companyName": czoneInfo.company.companyName, },
                        "zone": { "zoneId": czoneInfo.zone.zoneId, "zoneName": czoneInfo.zone.zoneName, },
                        "subZone": { "subZoneId": "", "subZoneName": "", },
                        reload: false,
                    });
                }
            }
        }
        setRecoilIsLoadinBox(false);
    }, [retData]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `area__left only-depth2 ${(treeOpen) && (isTreeOpen) ? "" : "close"}` },
            React.createElement("div", { className: "box__etc" },
                React.createElement("button", { type: "button", className: "btn btn-left", onClick: (e) => setParentIsTreeOpen(!isTreeOpen) },
                    React.createElement("span", { className: "hide" }, "\uD2B8\uB9AC\uBA54\uB274\uC811\uAE30\uD3BC\uCE58\uAE30"))),
            React.createElement("div", { className: "lnb" },
                React.createElement("ul", { className: "lnb-depth1" }, companyTree.map((company, idx) => (React.createElement(ZoneTree, { key: `comp_${idx.toString()}`, selTree: props.selTree, setSelTree: props.setSelTree, company: company }))))))));
}
;
export default ChangeTree;
function ZoneTree(props) {
    //props
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const company = props.company;
    function onClickZone(e, company, zone) {
        e.stopPropagation();
        setParentSelTree("EHC", { "company": { "companyId": company.companyId, "companyName": company.companyName, },
            "zone": { "zoneId": zone.zoneId, "zoneName": zone.zoneName, },
            "subZone": { "subZoneId": "", "subZoneName": "", },
            reload: false,
        });
    }
    return (React.createElement(React.Fragment, null, (company.zone) && (company.zone).map((zone, idx) => (React.createElement("li", { key: `compzone_${idx.toString()}`, className: (zone.zoneId === selTree.zone.zoneId) ? "active" : "", onClick: (e) => onClickZone(e, company, zone), id: `li_focus_${zone.zoneId}` },
        React.createElement("p", null,
            React.createElement("a", { href: "#" },
                React.createElement("span", null, company.companyName),
                React.createElement("span", null, zone.zoneName))),
        React.createElement(SubZoneTree, { selTree: props.selTree, setSelTree: props.setSelTree, zone: zone }))))));
}
function SubZoneTree(props) {
    //props
    const selTree = props.selTree;
    const setParentSelTree = props.setSelTree;
    const zone = props.zone;
    function onClickSubZone(e, subZone) {
        e.stopPropagation();
        setParentSelTree("EHC", Object.assign(Object.assign({}, selTree), { "subZone": { "subZoneId": subZone.subZoneId, "subZoneName": subZone.subZoneName } }));
    }
    return (React.createElement(React.Fragment, null, (zone.subZone) &&
        React.createElement("ul", { className: "lnb-depth2" }, zone.subZone.map((subZone, idx) => (React.createElement("li", { key: `sz_${idx.toString()}`, className: selTree.hasOwnProperty("subZone") ? (subZone.subZoneId === selTree.subZone.subZoneId) ? "active" : "" : "", onClick: (e) => onClickSubZone(e, subZone) },
            React.createElement("a", { href: "#" }, subZone.subZoneName)))))));
}
export function useDebounceEffect(fn, waitTime, deps) {
    useEffect(() => {
        const t = setTimeout(() => {
            fn.apply(undefined, deps);
        }, waitTime);
        return () => {
            clearTimeout(t);
        };
    }, deps);
}
